const addToBasketNotification = () => {
    const buyBTN = document.querySelector('#add-to-basket');
    const notification = document.querySelector('#add-to-basket-nitification');
    if (!buyBTN || !notification)
        return;
    buyBTN.addEventListener('click', () => {
        notification.classList.remove('hide');
    });
};
export default addToBasketNotification;
